import { DateTime } from "luxon";
import { luxonDateTimeToBackendDateOrDateTime } from "../../../../utils/dates/luxonDateTimeToBackendDateOrDateTime";
import type { ChangeableFieldData } from "../../../ChangeableFieldWidget/ChangeableFieldWidget";
import type { OperationPeriod } from "../ChangeableOperator";

/**
 * Converts ChangeableFieldWidget rows into snake_case OperationPeriods for the
 * backend (`company`, `first_date`, `last_date`). Inverse of
 * `convertOperatorsToChangeableFieldData`. `first_date` is required by the
 * serializer, so a missing `startDate` falls back to now (matching
 * `ChangeableOperator`).
 */
export function convertChangeableFieldDataToOperationPeriods(
  values: Array<ChangeableFieldData<number | null>>
) {
  return values.map<OperationPeriod>((value) => ({
    company: value.value as number,
    first_date: value.startDate
      ? luxonDateTimeToBackendDateOrDateTime(value.startDate)
      : luxonDateTimeToBackendDateOrDateTime(DateTime.now()),
    last_date: value.endDate
      ? luxonDateTimeToBackendDateOrDateTime(value.endDate)
      : null
  }));
}
